import apiCore from '../../utils/api-core';

export function getUser(url) {
	return apiCore.get(url);
}

export function getUsers() {
	return apiCore.get('/api/v1/users');
}

export function getUserById(id) {
	return apiCore.get(`/api/v1/users/${id}`);
}

export function createUser(data) {
	return apiCore.post('/api/v1/users', data);
}
export function updateUser(id, data) {
	return apiCore.put(`/api/v1/users/${id}`, data);
}
export function deleteUser(id) {
	return apiCore.delete(`/api/v1/users/${id}`);
}
export function toggleUserAccess(id){
	return apiCore.put(`/api/v1/users/toggle/${id}`)
}

export function sendResetEmail(email) {
	return apiCore.post('/api/v1/password-forgot', email);
}

export function resetPassword(data) {
	return apiCore.post('/api/v1/password-reset', data);
}

export function checkToken(token) {
	return apiCore.get(`/api/v1/password-reset/${token}`);
}

export function createUserBot(phoneNumber) {
	return apiCore.post('/api/v1/register/bot-creation', phoneNumber);
}

export function checkIfUserIsNew() {
	return apiCore.get('/api/v1/users/check-if-new');
}

export function createApiKeyForUser(id) {
	return apiCore.post(`/api/v1/create-api-key/${id}`);
}

export function getUsersByCompanyId(companyId) {
	return apiCore.get(`/api/v1/users/get-by-company-id/${companyId}`)
}

export function getUserAvatar(id) {
	return apiCore.get(`/api/v3/users/${id}/avatar`);
}

export function uploadAvatar(formData, onProgress) {
	const options = onProgress ? { onUploadProgress: onProgress } : {};
	return apiCore.post('/api/v1/files/user/avatar', formData, options);
}

export function updateUserProfile(id, data) {
	return apiCore.put(`/api/v3/users/${id}/profile`, data);
}

export function updateUserAuth(id, data) {
	return apiCore.put(`/api/v3/users/${id}/auth`, data);
}

export function updateNotificationSettings(id, data) {
	return apiCore.put(`/api/v3/users/${id}/notification/settings`, data);
}